export const DATE_PLACEHOLDER = "___ __, ____";
export const CARD_EXPIRY_DATE_MASK = [/\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
